import React from 'react';
import AccountCard from './AccountCard.jsx';
import AccountCardSkeleton from './AccountCardSkeleton.jsx';

export default function AccountsCardList({ 
  accounts, 
  isLoading, 
  items, 
  allitem, 
  onAccountSelect 
}) {
  if (isLoading) {
    return (
      <div className='my-6 space-y-4'>
        {Array.from({ length: 5 }).map((_, index) => (
          <AccountCardSkeleton key={index} />
        ))}
      </div>
    );
  }

  if (accounts.length === 0) {
    return (
      <div className='my-6'>
        <div className="flex flex-col justify-center items-center text-center py-12 bg-white border border-gray-200 rounded-xl">
          <img
            src="/assets/images/nodata.svg"
            alt="No data"
            className="w-20 mb-4"
          />
          <h2 className="text-base font-bold text-gray-700 mb-2">
            No Accounts Found
          </h2>
          <p className="text-gray-400 text-sm">There are no accounts to display</p>
        </div>
      </div>
    );
  }

  return (
    <div className='my-6 space-y-4'>
      {accounts.map((account, index) => (
        <AccountCard
          key={account?.login || index}
          account={account}
          items={items}
          allitem={allitem}
          onAccountSelect={onAccountSelect}
        />
      ))}
    </div>
  );
}

